import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap, tap } from 'rxjs';

import { Logger } from '@mobi/rwc-utils-ng-jslib';

import { NavigationService } from '../../service/navigation.service';
import { fatalErrorOccurred, fatalErrorOccurredOnUrl } from '../actions/fatal-error.actions';
import { LOT } from '../models/core.types';
import { State } from '../reducers/fatal-error.reducer';
import { EMPTY_ACTION } from '../state.util';

@Injectable()
export class FatalErrorEffects {
    private actions$ = inject(Actions);
    private navigationService = inject(NavigationService);
    private logger = inject(Logger);

    navigateOnFatalErrorOccurred$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fatalErrorOccurred),
            tap(({ fatalError }) => {
                if (
                    fatalError?.error?.status === 403 &&
                    fatalError?.error?.error?.requiredLot === LOT.STRONG_AUTH_3 &&
                    fatalError?.error?.error?.currentLot === LOT.MIDDLE_AUTH_2
                ) {
                    this.navigationService.navigateToElevate();
                } else {
                    this.navigationService.navigateToError();
                }
            }),
            map(() => fatalErrorOccurredOnUrl({ url: this.navigationService.locationHref() })),
        );
    });

    logOnFatalErrorOccurred$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fatalErrorOccurred),
            filter(({ fatalError }) => !!fatalError),
            tap(({ fatalError }) => this.log(fatalError)),
            switchMap(() => EMPTY_ACTION),
        );
    });

    private log(fatalError: State) {
        this.logger.error(
            `fatalError !!! type=${fatalError?.type} errorString=${JSON.stringify(fatalError)} occurredOnUrl=${fatalError?.occurredOnUrl}`,
        );
    }

    /*
    private extractErrorString(fatalError: State) {
        const toString = fatalError?.error?.toString?.();
        return toString == '[object Object]' ? this.toJsonString(fatalError, toString) : toString;
    }

    private toJsonString(fatalError: State, toString: string) {
        try {
            return JSON.stringify(fatalError?.error);
        } catch (e) {
            return toString;
        }
    } */
}
